import { render, staticRenderFns } from "./goveHome.vue?vue&type=template&id=32ae9f78&scoped=true"
import script from "./goveHome.vue?vue&type=script&lang=js"
export * from "./goveHome.vue?vue&type=script&lang=js"
import style0 from "./goveHome.vue?vue&type=style&index=0&id=32ae9f78&prod&lang=less&scoped=true"
import style1 from "./goveHome.vue?vue&type=style&index=1&id=32ae9f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae9f78",
  null
  
)

export default component.exports